import useSearchResults from '@/src/hooks/srp/useSearchResults'
import { useEffect, useRef } from 'react'

export const ScrollToTopElement = () => {
    const { selectedJourneyLeg } = useSearchResults()
    const elRef = useRef<HTMLSpanElement>(null)

    useEffect(() => {
        if (elRef.current) {
            elRef.current.scrollIntoView({ behavior: 'smooth' })
        }
    }, [selectedJourneyLeg])

    return <span ref={elRef}></span>
}
